import React from 'react';
import * as Constants from '../../utilities/constants/Constants';
import { Modal, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CancelButton from '../../UI/CancelButton/CancelButton';
import OKButton from '../../UI/OKButton/OKButton';
import './MessageDialogue.scss';
import { setDialogueFlag } from '../../redux/fabricCanvasActions';

const MessageDialogue = props => {
  const { page, dialogueParams, dispatchers } = props;
  const dialogButtons = dialogueParams.buttonTitles;
  let cancelTitle = '';
  let okTitle = '';
  if (dialogButtons) {
    cancelTitle = dialogButtons.cancel;
    okTitle = dialogButtons.finish;
  }

  let leftOffset =
    page === Constants.DESIGN_PAGE ? Constants.SIDE_BAR_WIDTH : 0;
  const mql = window.matchMedia('(max-width: 767px)');
  if (mql.matches) {
    leftOffset = 0;
  }

  const handleOKClick = () => {
    if (dialogueParams.onclick !== null) {
      dialogueParams.onclick();
    }
    dispatchers.setDialogueFlag(false);
  };

  const handleCancelClick = () => {
    if (dialogueParams.onCancel !== null) {
      dialogueParams.onCancel();
    }
    dispatchers.setDialogueFlag(false);
  };

  return (
    <div>
      <Modal
        className='error-details-modal'
        isOpen={dialogueParams.dialogueFlag}
        contentClassName='border-0 bg-transparent'
        backdropClassName='error-t-backdrop'
        centered
        style={{ left: `${leftOffset}px` }}
      >
        <ModalBody className='rounded-1'>
          <div>
            <div style={{ marginBottom: '12px' }}>
              {dialogueParams.dialoagTitleIcon ? (
                <img
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10
                  }}
                  src={dialogueParams.dialoagTitleIcon}
                  alt='icon'
                />
              ) : null}

              <span
                style={{
                  fontSize: '20px',
                  marginBottom: '12px',
                  color: '#4A4A4A',
                  verticalAlign: 'middle',
                  font: 'bold 20px/26px HPSimplifiedLight, Arial, sans-serif'
                }}
              >
                {dialogueParams.dialogueTitle}
              </span>
            </div>

            <p
              style={{
                fontSize: '13px',
                marginBottom: '3rem',
                color: dialogueParams.color,
                fontFamily: 'HPSimplifiedLight, Arial, sans-serif'
              }}
            >
              {dialogueParams.dialogueDescription}
            </p>

            <div
              style={{
                float: 'right',
                marginTop: '10px',
                marginBottom: '20px'
              }}
            >
              {cancelTitle !== '' ? (
                <CancelButton
                  clickHandler={handleCancelClick}
                  buttonLabel={cancelTitle}
                />
              ) : null}
              {okTitle !== '' ? (
                <OKButton clickHandler={handleOKClick} buttonLabel={okTitle} />
              ) : null}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    dialogueParams: state.fabricCanvas.dialogueParams,
    page: state.pageController.currentPageIndex
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      setDialogueFlag: bindActionCreators(setDialogueFlag, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageDialogue);
